import { sendRequest, smoothScroll } from '@html/_common/utils';
import SliderPopup from '@scout/components/slider-popup/slider-popup';

// Constant for mobile breakpoint (phones only, not tablets)
const MOBILE_BREAKPOINT = 767;

export default class AOTourPricePayByInstallmentsPopup {
  constructor(eventCategory, paymentInfo = {}) {
    this.eventCategory = eventCategory;
    this.TEMPLATES_ENDPOINT = '/api/tours/above-fold-templates';
    this.paymentInfo = paymentInfo;

    this.selectors = {
      wrapper: '.js-ao-tour-pay-by-installments-popup__overlay',
      trigger: '.js-ao-tour-above-fold__installments--learn-more',
      closeBtn: '.js-scout-slider-popup__close, .js-ao-tour-pay-by-installments-popup__close',
      departureDateClass: 'js-ao-tour-pay-by-installments-popup__content-text--departure-label',
      checkAvailabilityBtn: '.js-ao-tour-pay-by-installments-popup__check-availability',
      sliderPopupWrapper: '.js-scout-slider-popup-installments',
      sliderPopupOverlay: '.js-scout-slider-popup__overlay',
    };
    this.templateLoading = false;
    this.templateLoaded = false;
    this.sliderPopup = null;
    this.isMobile = window.innerWidth < MOBILE_BREAKPOINT;

    // Listen for resize events to update mobile status
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  handleResize() {
    this.isMobile = window.innerWidth < MOBILE_BREAKPOINT;
  }

  init() {
    $('body').on('click', this.selectors.closeBtn, () => {
      this.togglePopup(false);
    });

    $('body').on('click', this.selectors.trigger, () => {
      if (this.templateLoading) {
        return;
      }
      if (!this.templateLoaded) {
        this.loadPopup();
        return;
      }
      this.togglePopup(true);
    });

    // Add click handlers for date and check availability button
    // Use direct event delegation for better performance and reliability
    $('body').on('click', `.${this.selectors.departureDateClass}, ${this.selectors.checkAvailabilityBtn}`, (e) => {
      e.stopPropagation(); // Prevent the click from closing the popup
      this.scrollToAvailability();
    });
  }

  loadPopup() {
    this.templateLoading = true;

    sendRequest(
      this.TEMPLATES_ENDPOINT,
      {
        action: 'pay-by-installments/pay-by-installments-popup',
        token: window.csrf,
      },
      (data) => {
        this.templateLoading = false;
        if (data.success === true) {
          // Create a temporary div to hold the component HTML
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = data.component;

          // Update the HTML with payment info before appending to the DOM
          if (this.paymentInfo) {
            const {
              noFeesText,
              departureDate,
              departureDateRaw,
              payTodayText,
              paymentPlanText,
            } = this.paymentInfo;

            // Find and update elements
            const contentTextElement = tempDiv.querySelector('.js-ao-tour-pay-by-installments-popup__content-text');
            if (contentTextElement && noFeesText) {
              // Clear the element
              contentTextElement.textContent = '';

              // Add the text part
              const textNode = document.createTextNode(`${noFeesText} `);
              contentTextElement.appendChild(textNode);

              // Add the styled date part if available
              if (departureDate) {
                const dateSpan = document.createElement('span');
                dateSpan.className = `${this.selectors.departureDateClass} js-ao-tour-pay-by-installments-popup__content-text--departure-label ao-tour-pay-by-installments-popup__content-text--departure-label`;
                dateSpan.textContent = departureDate;
                if (departureDateRaw) {
                  dateSpan.dataset.date = departureDateRaw;
                  // Extract month-year for filtering
                  const dateObj = new Date(departureDateRaw);
                  const monthYearFormat = `${String(dateObj.getMonth() + 1).padStart(2, '0')}-${dateObj.getFullYear()}`;
                  dateSpan.dataset.monthYear = monthYearFormat;
                }
                contentTextElement.appendChild(dateSpan);
              }
            }

            // Add payment details if they don't exist
            const contentDiv = tempDiv.querySelector('.js-ao-tour-pay-by-installments-popup__content');
            if (contentDiv && payTodayText && paymentPlanText) {
              // Find the position to insert after the first paragraph
              const firstParagraph = contentDiv.querySelector('p');
              if (firstParagraph) {
                // Create deposit paragraph
                const depositPara = document.createElement('p');
                depositPara.className = 'ao-tour-pay-by-installments-popup__content-title';
                depositPara.innerHTML = `<strong>${payTodayText}</strong>`;

                // Create payment plan paragraph
                const paymentPlanPara = document.createElement('p');
                paymentPlanPara.className = 'ao-tour-pay-by-installments-popup__content-text';
                paymentPlanPara.textContent = paymentPlanText;

                // Insert after first paragraph
                firstParagraph.insertAdjacentElement('afterend', depositPara);
                depositPara.insertAdjacentElement('afterend', paymentPlanPara);
              }
            }
          }

          // Check if this is mobile and create a slider popup container if needed
          if (this.isMobile) {
            // Create slider popup container if needed
            if (!document.querySelector(this.selectors.sliderPopupWrapper)) {
              const sliderDiv = document.createElement('div');
              sliderDiv.className = this.selectors.sliderPopupWrapper.substring(1); // Remove the dot
              sliderDiv.innerHTML = AOTourPricePayByInstallmentsPopup.createSliderPopupHTML(tempDiv.innerHTML);
              document.body.appendChild(sliderDiv);

              // Initialize the slider popup
              this.sliderPopup = new SliderPopup({
                wrapper: this.selectors.sliderPopupWrapper,
                onClose: () => {},
              });
              // Initialize the slider popup events
              this.sliderPopup.initialize();
            }
          } else {
            // For desktop, use the regular popup
            $('body').append(tempDiv.innerHTML);
          }

          this.templateLoaded = true;
          this.togglePopup(true);
        }
      },
      {},
      () => {
        this.templateLoading = false;
        this.templateLoaded = false;
      },
    );
  }

  static createSliderPopupHTML(contentHTML) {
    // Extract content from the regular popup
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = contentHTML;

    const modalContent = tempDiv.querySelector('.js-scout-component__modal-content');
    const modalHeading = tempDiv.querySelector('.js-scout-component__modal-heading');

    let content = '';
    let title = '';

    if (modalContent) {
      content = modalContent.innerHTML;
    }

    if (modalHeading) {
      title = modalHeading.textContent;
    }

    // Create slider popup HTML with overlay
    return `
      <div class="scout-slider-popup__overlay js-scout-slider-popup__overlay"></div>
      <dialog open class="scout-slider-popup__container js-scout-slider-popup__container">
        <span class="scout-slider-popup__close js-scout-slider-popup__close"></span>
        <div class="scout-slider-popup__title-container ao-tour-pay-by-installments-popup__title">
          <span class="scout-slider-popup__title-text">${title}</span>
        </div>
        ${content}
      </dialog>
    `;
  }

  scrollToAvailability() {
    // Close the popup first
    this.togglePopup(false);

    // Get the departure date info
    const $dateElement = $(`.${this.selectors.departureDateClass}`);
    const fullDate = $dateElement.data('date');
    const dateObj = new Date(fullDate);
    const monthYear = `${String(dateObj.getMonth() + 1).padStart(2, '0')}-${dateObj.getFullYear()}`;

    // Wait a short time to allow the popup to close
    setTimeout(() => {
      // Find and scroll to availability section
      const $availabilitySection = $('.js-ao-tour-availability__filters');

      if ($availabilitySection.length) {
        // First scroll to the availability section
        smoothScroll({
          to: $availabilitySection,
          duration: 1000,
        });

        // Click the correct month filter if available
        if (monthYear) {
          const $monthFilter = $(`.js-ao-tour-availability__filters-button[data-val="${monthYear}"]`);
          if ($monthFilter.length) {
            $monthFilter.click();

            // After clicking month filter, wait for date cards to load
            setTimeout(() => {
              // Convert the full date to the format used in data-parameter (DD.MM.YYYY)
              const dateParts = fullDate.split('-');
              const formattedDate = `${dateParts[2]}.${dateParts[1]}.${dateParts[0]}`;

              // Try to find the card by looking for buttons with matching date parameter
              const $dateCard = $(`.js-am-tour-availability__variant button[data-parameter*="date=${formattedDate}"]`).closest('.js-am-tour-availability__variant');

              if ($dateCard.length) {
                smoothScroll({
                  to: $dateCard,
                  duration: 300,
                });
              }
            }, 1000); // Wait 1s for cards to load
          }
        }
      }
    }, 300);
  }

  togglePopup(toggle) {
    if (this.isMobile && this.sliderPopup) {
      if (toggle) {
        // For mobile, show the slider popup and wrapper
        const wrapperElement = document.querySelector(this.selectors.sliderPopupWrapper);
        wrapperElement.classList.remove('hid');
        // Use the SliderPopup component to open the dialog (which also handles the overlay)
        this.sliderPopup.openDialog();
      } else {
        // Use the SliderPopup component to hide the dialog (which also handles the overlay)
        this.sliderPopup.hideDialog();
        // Add a small delay before hiding the wrapper to allow animations to complete
        setTimeout(() => {
          const wrapperElement = document.querySelector(this.selectors.sliderPopupWrapper);
          if (wrapperElement) {
            wrapperElement.classList.add('hid');
          }
        }, 300);
      }
    } else {
      // For desktop, use the regular popup
      $('body').toggleClass('layer', toggle);
      $('html').toggleClass('layer', toggle);
      $(this.selectors.wrapper).toggleClass('hid', !toggle);

      if (toggle) {
        if (!$.magnificPopup) return;

        $.magnificPopup.close();
      }
    }
  }
}
